exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "md-form-field {\n  font-size: 80%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/SharedModule/DatepickerComponent/datepicker.component.scss
// module id = ../../../../../src/SharedModule/DatepickerComponent/datepicker.component.scss
// module chunks = main